import { React, useState, useEffect } from 'react';
import NavigationUser from '../../components/common/navigationUser/NavigationUser';
import {
  CustomButton,
  CustomPaginate,
  LoadingTable,
} from '../../components/utils/Utils';
import OrderModal from './modal/OrderModal';
import style from './perfil.module.scss';
import apiConnect from '../../config/apiConfig';
import axios from './../../config/apiConfig';

const Perfil = () => {
  const { container, orderItem, totalDetails, loadingPage, spinner } = style;
  const [ordersModalShow, setOrdersModalShow] = useState(false);
  const [user, setUser] = useState('');
  const [buys, setBuys] = useState([]);
  const [order, setOrder] = useState({});
  const [loading, setLoading] = useState(false);
  const [givenPage, setGivenPage] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [reqStatus, setReqStatus] = useState(false);
  const [totalized, setTotalized] = useState({});
  const [userLoad, setUserLoad] = useState(false);
  const [totalLoad, setTotalLoad] = useState(false);

  useEffect(async () => {
    const getUser = async () => {
      const id = localStorage.getItem('id');
      const response = await apiConnect.get(`/users/${id}`);
      setUser(response.data.data[0]);
      setUserLoad(true);
    };
    const getTotals = async () => {
      const { data } = await axios.get('users/totalized-orders');
      setTotalized({
        totalNumberOfCombos: data.data[0].totalNumberOfCombos,
        totalWithoutDiscount: data.data[0].totalWithoutDiscount,
        totalWithDiscount: data.data[0].totalWithDiscount,
        totalDiscount: data.data[0].totalDiscount,
      });
      setTotalLoad(true);
    };
    await getTotals();
    setLoading(true);
    await getUser();
    setLoading(false);
  }, []);

  useEffect(async () => {
    const getBuys = async () => {
      setBuys([]);
      setLoading(true);
      const response = await apiConnect.get(`/orders?page=${page}`);
      setLoading(false);
      setBuys(response.data.data[0].orders);
      setTotalPages(response.data.data[0].totalPages);
      setGivenPage(response.data.data[0].page);
    };

    if (page !== givenPage) {
      setReqStatus(false);
      await getBuys();
      setReqStatus(true);
    }
  }, [page]);

  const handleOpenModal = (order) => {
    setOrder(order);
    setOrdersModalShow(true);
  };

  return (
    <>
      {totalLoad && userLoad ? (
        ''
      ) : (
        <div className={loadingPage}>
          <LoadingTable />
        </div>
      )}
      <NavigationUser shadow={true} brandSize="125px" />
      <div className={container}>
        <div>
          <div>
            <div>
              <h2>{user?.pharmacy?.name}</h2>
              <h3>Nro. de cuenta: {user?.accountNumber}</h3>
            </div>
          </div>
          <div className={totalDetails}>
            <div>
              <h3>
                Combos comprados: {parseFloat(totalized?.totalNumberOfCombos)}
              </h3>
            </div>
            <div>
              <h3>
                Total sin descuento: $
                {parseFloat(totalized?.totalWithoutDiscount)?.toFixed(2)}
              </h3>
            </div>
            <div>
              <h3>
                Total de descuentos:{' '}
                {(parseFloat(totalized?.totalDiscount) * 100)?.toFixed(2)}%
              </h3>
            </div>
            <div>
              <h3>
                Total con descuentos: $
                {parseFloat(totalized?.totalWithDiscount)?.toFixed(2)}
              </h3>
            </div>
          </div>
        </div>
        <div>
          <div>
            <h2>Tus ordenes de compra</h2>
            <CustomPaginate
              setPage={setPage}
              page={page}
              totalPages={totalPages}
              centered={{ alignItems: 'center' }}
              style={{
                width: 'unset',
                border: '0',
                padding: '0',
                background: 'unset',
                borderRadius: 'unset',
                flex: '1 1',
              }}
            />
          </div>
          <div>
            <div className={orderItem} key={order._id}>
              <div>
                <h3>#</h3>
              </div>
              <div>
                <h3>Nombre</h3>
              </div>
              <div>
                <h3>Total sin descuento</h3>
              </div>
              <div>
                <h3>Descuento</h3>
              </div>
              <div>
                <h3>Total con descuento</h3>
              </div>
              <div></div>
            </div>
            {reqStatus && buys.length === 0 && !loading ? (
              <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
                <b>
                  <i>Todavia no realizo compras</i>
                </b>
              </div>
            ) : (
              ''
            )}
            {loading ? (
              <div className={spinner}>
                <LoadingTable />
              </div>
            ) : (
              buys.map((order, index) => (
                <div className={orderItem} key={order._id}>
                  <div>
                    <h3>{index + 1}</h3>
                  </div>
                  <div>
                    <h3>
                      {order?.comboData?.name ||
                        order?.products[0].product?.description}
                    </h3>
                  </div>
                  <div>
                    <h3>
                      ${parseFloat(parseFloat(order.orderSubtotal).toFixed(2))}
                    </h3>
                  </div>
                  <div>
                    <h3>
                      {`${
                        order?.totalizedDiscount
                          ? parseFloat(
                            (
                              parseFloat(order?.totalizedDiscount) * 100
                            ).toFixed(2),
                          )
                          : '0'
                      }%`}
                    </h3>
                  </div>
                  <div>
                    <h3>
                      $
                      {parseFloat(
                        parseFloat(order.orderTotalWithDiscount).toFixed(2),
                      )}
                    </h3>
                  </div>
                  <div>
                    <CustomButton
                      content="VER COMPRA"
                      size="bg"
                      color="btnPrimary"
                      onclick={() => handleOpenModal(order)}
                    />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {ordersModalShow && (
        <OrderModal
          state={ordersModalShow}
          set={setOrdersModalShow}
          order={order}
        />
      )}
    </>
  );
};

export default Perfil;
